import { connect } from 'react-redux'
import { doShowModal } from 'actions/modals'
import { CANNED_REPLIES } from 'constants/modal_types'
import { selectIsBrowsingCannedReplies } from 'selectors/modals'
import { selectShowCannedModal } from 'selectors/page'
import Dropup from './view'

const select = state => ({
  isMenuVisible: selectIsBrowsingCannedReplies(state),
  open: selectShowCannedModal(state),
})

const perform = dispatch => ({
  doShowCannedReplyModal: modalProps =>
    dispatch(doShowModal(CANNED_REPLIES, modalProps)),
})

export default connect(select, perform)(Dropup)
